import React, { memo } from 'react';
import styles from 'Custom/Table/AlternativeTable.module.scss';
import RichText from 'Custom/RichText/index';

const TABLE_SIZE = {
  default: styles.default,
  sm: styles.sm,
  compact: styles.compact,
};

const AlternativeTable = ({
  className = 'default',
  title = '',
  content = [],
  children,
  ...props
}) => {
  // Split className to handle multiple classes (e.g., "sm side-effects-new")
  const classes = className.split(' ');
  const sizeClass = classes.find(cls => TABLE_SIZE[cls]) || 'default';
  const baseClassName = TABLE_SIZE[sizeClass];
  const additionalClasses = classes.filter(cls => !TABLE_SIZE[cls]).join(' ');

  return (
    <section className={`${styles.wrapper} ${baseClassName} ${additionalClasses}`} {...props}>
      {content && (
        <RichText data-qa-tag="table-richText">
          <table aria-label={title} data-qa-tag="table">
            <tbody data-qa-tag="table-tbody">
              {content.map((item, i) => (
                <tr key={`table-row-${i}`} data-qa-tag="table-tr">
                  <th className={styles.tableCell} data-qa-tag="table-th">
                    {item.title}
                  </th>
                  <td className={styles.tableCell} data-qa-tag="table-td">
                    {item.body}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </RichText>
      )}
    </section>
  );
};

const MemoTable = memo(AlternativeTable);

export { MemoTable as AlternativeTable };
